import { FormInstance, List } from 'antd';
import { Container, Section, SectionTitle } from '../style';
import { StyledListItem } from '../../../../styles/listItem';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store';
import {
  fetchTemplateIssues,
  linkIssueToTemplate,
  selectDraftTemplate,
  selectTemplateCurrentIssues,
} from '../../../../slices/templates';
import IssueCard from '../../../../components/issueCard';
import { Issue } from '../../../../types';
import { useEffect } from 'react';
import IssueForm from '../../../../components/issueForm';

const AddIssue = ({ form }: { form: FormInstance }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const draftTemplate = useSelector(selectDraftTemplate);

  const issues = useSelector(selectTemplateCurrentIssues);

  const handleSubmit = async (issue: Issue) => {
    dispatch(
      linkIssueToTemplate({
        issue,
      })
    );
  };

  useEffect(() => {
    if (draftTemplate?.templateID) {
      dispatch(fetchTemplateIssues({ templateId: draftTemplate.templateID }));
    }
  }, []);

  return (
    <Container>
      <SectionTitle>Add New Issue</SectionTitle>
      <Section>
        <IssueForm
          templateID={String(draftTemplate?.templateID)}
          form={form}
          onSubmit={handleSubmit}
        />
      </Section>
      {issues?.length ? (
        <>
          <p>Issues ({issues?.length})</p>
          <Section>
            <List>
              {issues.map((i) => (
                <StyledListItem key={i.issueID}>
                  <IssueCard issue={i}></IssueCard>
                </StyledListItem>
              ))}
            </List>
          </Section>
        </>
      ) : null}
    </Container>
  );
};

export default AddIssue;
